import { interpolate } from 'd3-interpolate'
import {get as projection} from '..'
import Transformer from './transformer'
import * as geo from 'd3-geo'

const getRotate = projection => {
  return projection.rotate ? projection.rotate() : [0, 0, 0]
}

const getCenter = projection => {
  return projection.center ? projection.center() : [0, 0]
}

class DefaultTransformer extends Transformer {

  static match (d0, d1) {
    return true
  }

  constructor (enter, exit, opts) {
    super(enter, exit, opts)

    this.enter = enter
    this.exit = exit

    this.d1 = enter.datum()

    this.d1.projection = projection(this.d1.node, this.d1.geojson, opts)
    this.d1.path = geo.geoPath().projection(this.d1.projection)

    // default, start and end scales are the same.
    let s0 = this.d1.projection.scale()
      , t0 = this.d1.projection.translate()
      , c0 = getCenter(this.d1.projection)
      , r0 = getRotate(this.d1.projection)

    // If there are exiting nodes, set the starting data
    if (exit.size()) {
      // There was a previous plot, start at its projection
      let projection = exit.datum().projection
      s0 = projection.scale()
      t0 = projection.translate()
      r0 = getRotate(projection)
      c0 = getCenter(projection)
    }

    this.paths = this.enter.selectAll('path')

    this.interpolaters = {
      center: interpolate(c0, getCenter(this.d1.projection)),
      rotate: interpolate(r0, getRotate(this.d1.projection)),
      scale: interpolate(s0, this.d1.projection.scale()),
      translate: interpolate(t0, this.d1.projection.translate())
    }
  }

  transform (t) {
    let scale = this.interpolaters.scale(t)
      , translate = this.interpolaters.translate(t)
      , center = this.interpolaters.center(t)
      , rotate = this.interpolaters.rotate(t)

    // Update the scale and translate
    // We have to interpolate the projection. If you interpolate the path, you'll
    // end up in funky sitations where the path control points don't match
    this.d1
        .projection
        .scale(scale)
        .translate(translate)

    if (this.d1.projection.rotate) {
      this.d1.projection.rotate(rotate)
    }

    if (this.d1.projection.center) {
      this.d1.projection.center(center)
    }

    this.paths.attr('d', this.d1.path)

    this.exit
        .selectAll('path')
        .attr('d', this.d1.path)
  }

}

export default DefaultTransformer
